import { customerAddressFragment } from './customerAddressFragment';

export const customerFragment = `
  fragment CustomerFragment on Customer {
    id
    firstName
    lastName
    displayName
    emailAddress {
        emailAddress
    }
    phoneNumber {
        phoneNumber
    }
    defaultAddress {
      id
    }
    addresses(first:10) {
      edges{
        node {
          ...CustomerAddressFragment
        }
      }
    }
    orders(first: 100, reverse:true) {
      edges {
        node {
            id
            purchasingEntity {
                __typename
                ... on Customer {
                    id
                    emailAddress{
                        emailAddress
                    }
                }
                ... on PurchasingCompany {
                    company{
                        id
                        name
                    },
                    location{
                        id
                        name
                    }
                }
            }
            name
            number
            email
            cancelReason
            processedAt
            financialStatus
            totalPrice {
                amount
                currencyCode
            }
            totalTax {
                amount
            }
            shippingAddress {
                ...CustomerAddressFragment
            }
            totalShipping {
                amount
                currencyCode
            }
            lineItems(first:100) {
                edges {
                node {
                    customAttributes {
                    key
                    value
                    }
                    title
                    quantity
                    currentTotalPrice {
                    amount
                    }
                    variantId
                    sku
                }
                }
            }
            fulfillments(first:10) {
                edges {
                    node {
                        trackingInformation {
                            url
                            number
                        }
                    }
                }
            }
        }
      }
    }
    companyContacts(first:10) {
        edges {
            node {
                id
                title 
                company {
                    name
                    locations(first: 10) {
                        edges {
                            node {
                            id
                            name
                            }
                        }
                    }
                }
                orders(first: 100, reverse:true) {
                    edges {
                      node {
                          id
                          name
                          number
                          email
                          processedAt
                          totalPrice {
                              amount
                              currencyCode
                          }
                          totalTax {
                              amount
                          }
                          shippingAddress {
                            ...CustomerAddressFragment
                          }
                          lineItems(first:100) {
                              edges {
                              node {
                                  customAttributes {
                                  key
                                  value
                                  }
                                  title
                                  quantity
                                  currentTotalPrice {
                                  amount
                                  }
                                  variantId
                              }
                              }
                          }
                          fulfillments(first:10) {
                              edges {
                                  node {
                                      trackingInformation {
                                          url
                                          number
                                      }
                                      status
                                  }
                              }
                          }
                      }
                    }
                  }
            }
        }
    }
  }
  ${customerAddressFragment}
`;
